/// <amd-module name="SuiteCommerce.LookBook.Look.Router"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.Look.Router", ["require", "exports", "Backbone", "SuiteCommerce.LookBook.Look.Model", "SuiteCommerce.LookBook.Look.View"], function (require, exports, Backbone_1, Look_Model_1, Look_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookRouter = void 0;
    var LookRouter = /** @class */ (function (_super) {
        __extends(LookRouter, _super);
        function LookRouter(options) {
            var _this = _super.call(this, options) || this;
            _this.application = options.application;
            _this.environment = options.application.getComponent('Environment');
            return _this;
        }
        Object.defineProperty(LookRouter.prototype, "routes", {
            // @ts-ignore
            get: function () {
                return {
                    'lookbook/:lookbook/:look(?*)': 'look'
                };
            },
            enumerable: false,
            configurable: true
        });
        LookRouter.prototype.look = function (lookBookUrl, lookUrl) {
            var _this = this;
            var model = new Look_Model_1.LookModel();
            model
                .fetch({
                data: {
                    urlcomponent: lookUrl,
                },
            })
                .done(function () {
                var view = new Look_View_1.LookView({
                    application: _this.application,
                    model: model,
                });
                view.showContent();
                view.reloadSlider();
                view.logShowSpecificLook();
            });
        };
        return LookRouter;
    }(Backbone_1.Router));
    exports.LookRouter = LookRouter;
});
